import { vendors_ES_MX } from "#pages/org/vendors/translations";
import { categories } from "./categories";
import { chartOfAccounts } from "./chart-of-accounts";
import { clientArea } from "./client-area/";
import { clients } from "./clients";
import { communication } from "./communication/";
import { employees } from "./employees/";
import { fiscalBoard } from "./fiscal-board";
import { fiscalCouvertForm } from "./fiscal-couvert-form";
import { fiscalData } from "./fiscal-data";
import { fiscalGroupForm } from "./fiscal-group-form";
import { minimmConsummation } from "./fiscal-minimum-consummation-form";
import { fiscalProfileForm } from "./fiscal-profile-form";
import { fiscalRecharge } from "./fiscal-recharge-form";
import { fiscalSettings } from "./fiscal-settings";
import { giftCard } from "./gift-card";
import { giftback } from "./giftback";
import { helpers } from "./helpers";
import { internalSalesCampaign } from "./internal-sales-campaign";
import { loyalty } from "./loyalty";
import { productFeatureTemplates } from "./product-feature-templates";
import { ORG_PRODUCTS_ES_MX } from "./products";
import { reports } from "./reports";
import { satisfactionSurvey } from "./satisfaction-survey";
import { teamAndRoles } from "./team-and-roles";

export const orgES_MX = {
	employees,
	fiscalBoard,
	fiscalData,
	fiscalProfileForm,
	fiscalCouvertForm,
	fiscalGroupForm,
	fiscalSettings,
	helpers,
	loyalty,
	clients,
	productFeatureTemplates,
	communication,
	products: ORG_PRODUCTS_ES_MX,
	clientArea,
	reports,
	satisfactionSurvey,
	chartOfAccounts,
	minimmConsummation,
	teamAndRoles,
	vendors: vendors_ES_MX,
	fiscalRecharge,
	giftback,
	giftCard,
	internalSalesCampaign,
	categories,
};
